import {writable} from 'svelte/store';

let geosObject = {
    list: [],
    tree: [],

    agents: [],

    selected_id: 0,
    last_selected_id: 0,
    last_agent_id: 0,
    marked_id: 0,
    edit_id: null,
    search_term: '',

    match_source: 0,
};

const {get, set, update, subscribe} = writable(geosObject)

const geos = {
    subscribe,
    update,
    set: o => {
        set(geosObject);
    },
}

export default geos;